// ── Bone ────────────────────────────────────────────────
export function Bone({ w = "100%", h = 14, r = 6, mt = 0, mb = 0, style = {} }) {
  return (
    <div
      className="sk"
      style={{ width: w, height: h, borderRadius: r, marginTop: mt, marginBottom: mb, ...style }}
    />
  );
}

// ── FieldSkeleton: label + input block ──────────────────
export function FieldSkeleton({ labelW = 100 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <Bone w={labelW} h={10} />
      <Bone w="100%" h={40} r={8} />
    </div>
  );
}

// ── GridRow3: three equal columns ───────────────────────
export function GridRow3({ mb = 20 }) {
  return (
    <div className="sk-grid-3" style={{ marginBottom: mb }}>
      <FieldSkeleton /><FieldSkeleton /><FieldSkeleton />
    </div>
  );
}

// ── GridRow2: two equal columns ─────────────────────────
export function GridRow2({ mb = 20 }) {
  return (
    <div className="sk-grid-2" style={{ marginBottom: mb }}>
      <FieldSkeleton /><FieldSkeleton />
    </div>
  );
}

// ── GridRow2_1: wide + narrow columns ───────────────────
export function GridRow2_1({ mb = 20 }) {
  return (
    <div className="sk-grid-2-1" style={{ marginBottom: mb }}>
      <FieldSkeleton /><FieldSkeleton />
    </div>
  );
}

// ── DividerSkeleton: section label between two lines ────
export function DividerSkeleton() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "20px 0 18px" }}>
      <Bone w="100%" h={1} r={1} />
      <Bone w={160} h={12} r={20} style={{ flexShrink: 0 }} />
      <Bone w="100%" h={1} r={1} />
    </div>
  );
}